import React, { FC } from 'react';

import { Text, Types } from '@marriott/mi-ui-library';

import { PointsWrapperProps } from './PointsWrapper.types';
import { StyledPointsWrapper } from './PointsWrapper.styles';
import { PointsWrapperHeader } from './PointsWrapperHeader';
import { PointsIconList } from './PointsIconList';
import { PointsCardGrid } from './PointsCardGrid';

export const PointsWrapper: FC<PointsWrapperProps> = ({
  hideComponent,
  componentId,
  header,
  headerTag,
  headerFontSize,
  description,
  iconListDetails,
  cardDetails,
  tracking,
}) => {
  if (hideComponent) return null;

  const hasIconList = Array.isArray(iconListDetails) && iconListDetails.length > 0;
  const hasCards = Array.isArray(cardDetails) && cardDetails.length > 0;
  const headingId = header ? `${componentId || 'points-wrapper'}-heading` : undefined;

  return (
    <StyledPointsWrapper
      data-testid="points-wrapper"
      data-component-name="o-account-PointsWrapper"
      id={componentId}
      className="container"
    >
      <div className="pointswrapper">
        <PointsWrapperHeader id={headingId} header={header} headerTag={headerTag} headerFontSize={headerFontSize} />

        {(hasIconList || hasCards) && (
          <div className="pointswrapper__grid">
            {hasIconList && (
              <div className="pointswrapper__list-col">
                {description && (
                  <Text
                    copyText={description}
                    fontSize={Types.size.medium}
                    element={Types.tags.paragraph}
                    customClass="pointswrapper__description t-font-m m-0 pb-3"
                  />
                )}
                <PointsIconList items={iconListDetails} />
              </div>
            )}

            {hasCards && (
              <div className="pointswrapper__cards-col">
                <PointsCardGrid
                  cards={cardDetails}
                  componentId={componentId}
                  sectionHeader={header}
                  tracking={tracking}
                />
              </div>
            )}
          </div>
        )}
      </div>
    </StyledPointsWrapper>
  );
};
